var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoices-index width-100"},[_c('TableWrapper',{attrs:{"table-columns":_vm.invoicesColumns,"table-key":"invoices","enable-selection":false},on:{"showInvoice":_vm.showInvoice,"showAttachment":_vm.showAttachment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }